import ApplicationController from '../application_controller'

class TypeController extends ApplicationController {
  connect () {
    this.handleTypeChange()
    this.element.addEventListener('change', this.handleTypeChange.bind(this))
  }

  handleTypeChange () {
    const type = this.element.value
    const statistics_types = ['select', 'multiselect']
    const checkbox = document.getElementById('statistics_filter_input')

    if (statistics_types.includes(type)) {
      checkbox?.classList.remove('hidden')
    } else {
      checkbox?.classList.add('hidden')
    }
  }
}

export default TypeController
